<template>
  <div class="contact-page">
    <section class="contact-hero">
      <img src="@/assets/image/contact_banner.png" alt="联系我们">
    </section>

    <section class="contact-main">
      <div class="container">
        <div id="info" class="contact-card-grid">
          <article v-for="item in contactItems" :key="item.title" class="contact-card">
            <img :src="item.icon" :alt="item.title">
            <h2>{{ item.title }}</h2>
            <p>{{ item.text }}</p>
          </article>
        </div>

        <div id="map" class="contact-map-wrap">
          <div ref="map" class="contact-map"></div>
          <div v-if="mapError" class="contact-map-fallback">
            <strong>深圳市千讯云创科技有限公司</strong>
            <span>地址：深圳市龙岗区坂田街道云里智能园4栋501</span>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
const BAIDU_MAP_AK = 'cg8sGxetRh4zuivBxDLI3CEB5E0fhL36'
const BAIDU_MAP_SCRIPT_ID = 'baidu-map-script'

export default {
  name: 'ContactView',
  data() {
    return {
      mapError: false,
      contactItems: [
        {
          title: '咨询热线',
          text: 'leibinhui@qxcloudtech.cn',
          icon: require('@/assets/image/contact_icon1.png')
        },
        {
          title: '办公地址',
          text: '深圳市龙岗区坂田街道云里智能园4栋501',
          icon: require('@/assets/image/contact_icon2.png')
        },
        {
          title: '服务时间',
          text: '周一至周五 9:00-18:00',
          icon: require('@/assets/image/contact_icon3.png')
        }
      ]
    }
  },
  mounted() {
    this.loadBaiduMap()
      .then(this.initMap)
      .catch(() => {
        this.mapError = true
      })
  },
  methods: {
    loadBaiduMap() {
      if (window.BMap) {
        return Promise.resolve()
      }

      const existingScript = document.getElementById(BAIDU_MAP_SCRIPT_ID)

      if (existingScript) {
        return new Promise((resolve, reject) => {
          existingScript.addEventListener('load', resolve, { once: true })
          existingScript.addEventListener('error', reject, { once: true })
        })
      }

      return new Promise((resolve, reject) => {
        window.initBaiduMapForContact = resolve

        const script = document.createElement('script')
        script.id = BAIDU_MAP_SCRIPT_ID
        script.src = `https://api.map.baidu.com/api?v=3.0&ak=${BAIDU_MAP_AK}&callback=initBaiduMapForContact`
        script.async = true
        script.onerror = reject
        document.head.appendChild(script)
      })
    },
    initMap() {
      if (!this.$refs.map || !window.BMap) {
        this.mapError = true
        return
      }

      const { BMap } = window
      const map = new BMap.Map(this.$refs.map)
      const point = new BMap.Point(114.075507, 22.635711)
      const marker = new BMap.Marker(point)
      const infoWindow = new BMap.InfoWindow(
        '<strong>深圳市千讯云创科技有限公司</strong><br>地址：深圳市龙岗区坂田街道云里智能园4栋501',
        {
          width: 300,
          height: 84,
          title: ''
        }
      )

      map.centerAndZoom(point, 15)
      map.enableScrollWheelZoom(true)
      map.addOverlay(marker)
      marker.openInfoWindow(infoWindow)
      marker.addEventListener('click', () => {
        marker.openInfoWindow(infoWindow)
      })
    }
  }
}
</script>
